import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vapidKey: null,
  loading: false,
  sidebarVisible: true,
  showMobileSidebar: false,
  showCustomerMenu: false,
  unsavedChanges: false,
  timezone: null,
  nearestSlot: null,
  updateStations: false,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setVapidKey(state, action) {
      state.vapidKey = action.payload;
    },
    setLoading(state, action) {
      console.log("Setting loading state to:", action.payload);
      state.loading = action.payload;
    },
    setSidebarVisible(state, action) {
      state.sidebarVisible = action.payload;
    },
    setShowMobileSidebar(state, action) {
      state.showMobileSidebar = action.payload;
    },
    setShowCustomerMenu(state, action) {
      state.showCustomerMenu = action.payload;
    },
    setUnsavedChanges(state, action) {
      state.unsavedChanges = action.payload;
    },
    setTimezone(state, action) {
      state.timezone = action.payload;
    },
    setNearestSlot(state, action) {
      state.nearestSlot = action.payload;
    },
    setUpdateStations(state, action) {
      state.updateStations = action.payload;
    }
  },
});

export const { setVapidKey, setLoading, setSidebarVisible, setShowMobileSidebar, setShowCustomerMenu, setUnsavedChanges, setTimezone, setNearestSlot, setUpdateStations } = appSlice.actions;
export default appSlice.reducer;
